import type { Ref } from 'vue';

import type { User } from '@/submodules/generated_types/types/user';

import type { UserWithExtraFields } from '../interfaces/user.interface';

export function userCityIsDefinedAndNotEmpty(
  user: Ref<UserWithExtraFields | User | null>
): boolean {
  return Boolean(user.value?.city);
}
